import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco, tomorrowNightBlue, github } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { Copy } from '../copy';

const syntaxStyle = tomorrowNightBlue;
const syntaxStyleInline = docco;
const syntaxCustomStyle = { border: '1px solid #222', padding: 20, borderRadius: 8 };

const inlineStyle = {
  display: 'inline',
  padding: '6px 8px',
  border: 0,
  borderRadius: 4,
};

const render = (str, secret) => '**';

export const Code = (props) => (
  <div
    style={{
      position: 'relative',
      alignItems: props.inline ? 'center' : null,
      display: props.inline ? 'inline-flex' : null,
      ...(props.style || {}),
    }}
  >
    {props.copy && (
      <div style={{ position: 'absolute', right: 10, zIndex: 10, ...(props.inline ? {} : { top: 10, right: 10 }) }}>
        <Copy value={props.code} onlyCheck style={{ color: props.inline ? 'black' : 'white' }} />
      </div>
    )}
    <SyntaxHighlighter
      {...{ ...props, inline: undefined, copy: undefined }}
      style={props.inline ? syntaxStyleInline : syntaxStyle}
      customStyle={{
        ...syntaxCustomStyle,
        ...(props.inline ? inlineStyle : {}),
        ...(props.copy ? { paddingRight: 40 } : {}),
      }}
    >
      {props.children ? props.children : render(props.code, props.hideCode)}
    </SyntaxHighlighter>
  </div>
);
